<template>
  <div>
    <sl-table ref="table" :enable-pager="false" :columns="columns" :data="annexs"></sl-table>
  </div>

</template>
<script>
const annexTypes = [
  { id: 1 , title:'法人身份证反面（人像面）'},
  { id: 2 , title:'法人身份证正面（国徽面）'},
  { id: 3 , title:'营业执照正本'},
  { id: 4 , title:'营业执照副本'},
  { id: 5 , title:'开户许可证/一般户引鉴卡'},
  { id: 6 , title:'近6个月收派件量',limit:5},
  { id: 8 , title:'经营场所（网点照片）',limit:5},
  { id: 9 , title:'实控人身份证反面（人像面）'},
  { id: 10, title:'实控人身份证正面（国徽面）'},
]

export default {
  data() {

    return {
      columns:[
        {
          title:'文件名称',
          key:'title',
          width:200,
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('sl-upload', {
                  props: {
                    limit: params.row.limit,
                    data: this.getExtraFields(params.row),
                    action: this.uploadUrl,
                  },
                  on: {
                    click: () => {
                      this.view(params)
                    }
                  }
                })
            ])
          }
        },
      ],
      annexTypes,
      annexs:[],
      loading:false
    }
  },

  props:{
    id:{

    },

    data:{
      default:function(){
        return []
      }
    }
  },

  watch:{
    id(val){
      if(val){
        this.query()
      }
    },
    data(val){
      if(val && val.length){
        this.render()
      }
    }
  },

  computed:{
    uploadUrl(){
      return this.$request.ciFileUploadUrl()
    }
  },

  created(){
    this.render()
  },

  mounted() {},

  methods: {
    query(){
      this.$request.ciEnterpriseFile(this.orderId).then(resp => {
        if(!resp.code){
          this.def = resp.data

          this.$utils.fill(this.form , this.def)

          this.goods = (resp.data || []).map(i=>({id:i.skuId , name:i.skuName , goodsNum:i.goodsNum}))

          this.$request.skus({pageSize:9999}).then(resp => {
            this.products = (resp.data.list || []).map(i=>({value:i.id , label :i.name , raw : i}))
          })

        }else{
          this.$Message.error({content:resp.message})
        }
      })
    },

    render(){
      let data = {}
      this.data.forEach(i=>{
        if('fileType' in i){
          data[i.fileType] = i
        }
      })

      this.annexs = this.annexTypes.map(i=>{
        let r = {fileType:i.id , enterpriseId: this.id , title:i.title , limit : i.limit || 1}
        if(data[i.id]){
          r.fileId = data[i.id].id
        }
        return r
      })

      console.log(this.annexs)
    },

    update({id , fileType}){
      let hit = this.annexs.find(i=>(i.fileType == fileType))
      if(hit){
        this.$set(hit, 'fileId', id);
      }
    },

    // getUploadUrl({fileType , fileId}){
    //   let enterpriseId = this.id
    //   return this.$request.ciFileUploadUrl() // + `?enterpriseId=${enterpriseId}&fileType=${fileType}` + (fileId ? `&fileId=${fileId}` : '')
    // },

    getExtraFields({fileType , fileId}){
      let opts = { enterpriseId : this.id , fileType }
      if(fileId) opts.fileId = fileId
      return opts
    },

    getDownloadUrl(id){
      return this.$request.orderAnnexUrl(id , true)
    },

    remove({row}){
      this.$ui.confirm(this.$request.orderAnnexDelete, `确定删除 ${row.title}？`)(row.fileId).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.update( { fileType: row.fileType } )
        }else{
          this.$Message.error(resp.message)
        }
      })
    },

  }
}
</script>